module.exports = __webpack_public_path__ + "static/img/help.874442b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/help.png
// module id = KfKJ
// module chunks = 136